
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CouponInfo, CouponType, CouponButtonType, CouponTipsType, NumberFontSize } from '../types';
import { getCurrencyCodeByType, getValidCurrencyType, nonChineseCharactersLength, parseCurrencyAria } from '../utils';
import { initLang } from '../i18n';
import { language } from '@tencent/ppd-base-libs';
import Amount from '../common/amount.vue';

@Component({ components: { Amount } })
export default class CouponMixin extends Vue {
  @Prop() lang!: string;
  @Prop({ default: () => ({}) }) couponInfo!: CouponInfo;
  parseCurrencyAria = parseCurrencyAria;

  created() {
    /**
     *  获取指定语言
     */
    initLang(this.lang || language.getLanguage());
  }
  /**
   * 是否是英文
   */
  public get isEn() {
    return this.lang === 'en';
  }

  /**
   * 是否为普通奖品券
   */
  public get isDefaultCoupon() {
    return this.couponInfo.couponType === CouponType.default;
  }

  /**
   * 是否为现金券
   */
  public get isCashCoupon() {
    return this.couponInfo.couponType === CouponType.cash;
  }

  /**
   * 是否为折扣券
   */
  public get isDiscountCoupon() {
    return this.couponInfo.couponType === CouponType.discount;
  }

  /**
   * 券是否被锁住
   */
  public get isLock() {
    return this.couponInfo.buttonType === CouponButtonType.lock;
  }

  /**
   * 券是否过期
   */
  public get isExpire() {
    return this.couponInfo.isExpire;
  }

  /**
   * 是否展示邮戳
   */
  public get isShowStamp() {
    return this.couponInfo.isShowStamp || this.couponInfo.isExpire;
  }

  /**
   * 是否展示按钮
   */
  public get isShowButton() {
    // 如果有傳isShowButton，優先用它判斷；否則則根據券isExpire判斷
    return this.couponInfo.isShowButton ? !this.couponInfo.isExpire : this.couponInfo.isShowButton;
  }

  /**
   * 是否展示手动开启提示
   */
  public get isShowManualTips() {
    return this.couponInfo.tipsType === CouponTipsType.manual && this.couponInfo.tipsText;
  }

  /**
   * 是否展示连锁提示（使用后领取下一张）
   */
  public get isShowChainTips() {
    return this.couponInfo.tipsType === CouponTipsType.chain && this.couponInfo.tipsText;
  }

  /**
   * 是否展示银行专属
   */
  public get isShowBankTips() {
    return this.couponInfo.tipsType === CouponTipsType.bank && this.couponInfo.tipsText;
  }

  /**
   * 是否展示优惠券底部提示条
   */
  public get isShowTips() {
    const result = this.isExpire ? !this.isExpire : !!(this.couponInfo.tipsText || this.couponInfo.tipsTextRight);
    return result;
  }

  /**
   * 是否为连锁券
   */
  public get isChain() {
    return this.couponInfo.isChain;
  }
  /** 折扣券单位：英文-off;中文-折 */
  public get discountUnitWithLang() {
    return this.isEn ? '%off' : '折';
  }

  /** 币种类型，默认为CurrencyType.HKD */
  public get currencyType() {
    return getValidCurrencyType(this.couponInfo.currencyType);
  }
  /** 币种码 */
  public get currencyCode() {
    return getCurrencyCodeByType(this.couponInfo.currencyType);
  };

  /**
   * 兑换
   */
  public async handleExchange() {
    // 发送消息给调用方
    this.$emit('getCoupon');
  }

  /**
   * 整券点击
   */
  public async couponClick() {
    // 发送消息给调用方
    this.$emit('couponClick');
  }

  /**
   * 给金额与折扣中的字符长度动态改变样式
   */
  public get numberFontStyle() {
    /** 获取金额与折扣 */
    const yuan = this.couponInfo.prizeAmountYuan?.toString() || '';
    const discount = this.couponInfo.prizeDiscount?.toString() || '';

    let numberLength = 0;
    let fontStyle = '';

    /** 获取金额数字长度 */
    if (yuan) {
      numberLength = yuan.length;
    }
    /** 获取折扣数字长度 */
    if (discount?.indexOf('.') !== -1) {
      numberLength = discount.length - 1;
    }
    /** 根据数字长度返回对应样式 */
    switch (numberLength) {
      case 3:
        fontStyle = NumberFontSize.s;
        break;

      case 4:
        fontStyle = NumberFontSize.xs;
        break;

      default:
        break;
    }
    return fontStyle;
  }

  /**
   * 英文下按钮文本样式处理
   */
  public get enButtionStyle() {
    if (!this.couponInfo.couponBtnText) {
      return;
    }
    const len = nonChineseCharactersLength(this.couponInfo.couponBtnText);
    let style = '';
    if (len > 6) {
      style = 'button-text-s';
    }
    return style;
  }

  /**
   * 提示条长度超出时做特殊处理
   */
  public get sdf() {
    if (!this.couponInfo.couponBtnText) {
      return;
    }
    const len = nonChineseCharactersLength(this.couponInfo.couponBtnText);
    let style = '';
    if (len > 6) {
      style = 'button-text-s';
    }
    return style;
  }
}
